import { useState } from "react";
import { Button } from "../components/ui/button";
import FormatterExampleCard from "../components/formatter/FormatterExampleCard";
import { FORMATTER_EXAMPLES } from "../data/formatterExamples";
import type { FormatterExamplesConfig } from "../components/formatter/types";
import { Heading } from "../components/ui/heading";
import ExamplesPageLayout from "@/components/layout/ExamplesPageLayout";

const EXAMPLES_PAGE_CONFIG: FormatterExamplesConfig = {
	initialVisibleCount: 3,
	showMore: true,
};

export default function ExamplesListPage() {
	const [visibleCount, setVisibleCount] = useState(EXAMPLES_PAGE_CONFIG.initialVisibleCount ?? 3);

	const visibleExamples = FORMATTER_EXAMPLES.slice(0, visibleCount);
	const hasMore =
		(EXAMPLES_PAGE_CONFIG.showMore ?? true) && visibleCount < FORMATTER_EXAMPLES.length;

	return (
		<ExamplesPageLayout width="6xl" paddingY="6">
			<Heading>Examples</Heading>
			<div className="space-y-6">
				{visibleExamples.map((example) => (
					<FormatterExampleCard
						key={example.id}
						title={example.label}
						titleHref={`/format/${example.slug}`}
						initialInput={example.text}
						defaultMode={example.contentType}
						defaultOptions={example.options}
					/>
				))}
			</div>

			{hasMore ? (
				<div className="mt-6 flex justify-center">
					<Button variant="secondary" onClick={() => setVisibleCount(FORMATTER_EXAMPLES.length)}>
						Show more examples
					</Button>
				</div>
			) : null}
		</ExamplesPageLayout>
	);
}
